import ProjectTreeInput from '@/components/projectTreeInput'
import ModifyPasswordDialog from '@/components/modifyPasswordDialog'
import cookie from '../../utils/Tools/index'
import {
  colorRGBtoHex
} from '../../utils/Tools/assist'
// import axios from 'axios'

export default {
  name: 'layout',
  components: {
    ProjectTreeInput,
    ModifyPasswordDialog
  },
  data () {
    return {
      // 用于菜单动态显示
      menu: [], // 菜单对象
      backgroundColor: '',
      fontColor: '',
      disFlag: [],
      submenu1: false,
      submenu2: false,
      submenu3: false,
      submenu4: false,
      adminDo: true,
      isEidet: false,
      i: -1,
      dialogVisible: false,
      activeIndex: '1',
      activeIndex2: '1',
      activeName: 'first',
      selected: 0,
      activeNames: ['1'],
      logoName: 'LOGO.png',
      userRole: '',
      /* userPicture: 'logo01.png', */
      // userPic: '../../static/images/hg.jpg',
      showtimeout: 200,
      dialogVisible1: false,
      oldpsd: '',
      newpsd: '',
      newpsd1: '',
      userInfo: {},
      isold: false,
      isnew: false,
      istColor1: false,
      istColor2: false,
      istColor3: false,
      isProjectSelectorShowed: false,
      projectName: '',
      projectId: null,
      projectNameFilter: ''
    }
  },
  computed: {
    classObj () {
      return {
        main: [`${this.$options.name}`],
        head: [`${this.$options.name}__head`],
        logo: [`${this.$options.name}__logo`],
        topNav: [`${this.$options.name}__topNav`],
        right: [`${this.$options.name}__right`],
        list: [`${this.$options.name}__list`],
        userPhoto: [`${this.$options.name}__list__userPhoto`],
        userPhotoIcon: [`${this.$options.name}__userPhotoIcon`, 'fontFamily', 'ryx-touxiang'],
        arrow: [`${this.$options.name}__arrow`],
        dialog: [`${this.$options.name}__dialog`]
      }
    },
    userAvatar () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.photoUrl
      } else {
        return null
      }
    },
    companyName () {
      return this.$store.getters.company.companyName
    },
    companyLogo () {
      return require('../../../static/images/logo-new.png')
      // const companyData = this.$store.getters.company
      // if (companyData.companyLogo) {
      //   return axios.defaults.baseURL + 'v1/image/1/' + companyData.companyLogo
      // } else {
      //   return require('../../../static/images/logo2.png')
      // }
    },
    companyTheme () {
      return this.$store.getters.company.companySkin
    },
    badgeValue () {
      const notification = this.$store.getters.notification
      return notification.todoCount + notification.messageUnreadCount
    }
  },
  created () {
    this.isProjectSelectorShowed = !this.$store.getters.user.isAdmin
    this.userRole = this.$store.getters.user.nickName
    for (let i in this.menu) {
      this.disFlag[i] = false
    }
    this.menu = this.$store.getters.menuList
  },
  mounted () {
    this.themeChanged()
  },
  watch: {
    newpsd () {
      this.isnewpsd()
    },
    companyTheme () {
      this.themeChanged()
    },
    $route (n, o) {
      if (n) {
        this.findCuttentMenu(this.menu, n.name)
      }
    }
  },
  methods: {
    findCuttentMenu (arr, menuName, idx) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].menuName === menuName) {
          this.activeIndex = idx ? idx + '-' + i : (i + '')
          return
        } else if (arr[i].sub_menu.length) {
          this.findCuttentMenu(arr[i].sub_menu, menuName, (i + ''))
        } else {
          // sonar规则校验语法必须else
        }
      }
    },
    async viewNotice () {
      this.$store.getters.notification.isPanelShow = true
    },
    // 修改密码
    isoldbn () {
      let userName = cookie.getCookie('user_name')
      let md5Oldpwd = this.$md5(this.oldpsd)
      let url = `user/checkUserNamePassWord?password=${md5Oldpwd}&userName=${userName}`
      this.$https
        .post(url)
        .then(response => {
          if (response.success === true) {
            this.isold = true
          }
        })
        .catch(error => {
          console.log(error)
          this.isold = false
        })
    },
    isnewpsd () {
      let strongRegex = new RegExp('^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$', 'g')
      let mediumRegex = new RegExp('^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$', 'g')
      let enoughRegex = new RegExp('(?=.{6,}).*', 'g')
      if (enoughRegex.test(this.newpsd) === false) {
        this.istColor3 = false
        this.istColor1 = false
        this.istColor2 = false
      } else if (mediumRegex.test(this.newpsd)) {
        this.istColor2 = true
        this.istColor1 = false
        this.istColor3 = false
      } else if (strongRegex.test(this.newpsd)) {
        this.istColor3 = true
        this.istColor1 = false
        this.istColor2 = false
      } else {
        this.istColor1 = true
        this.istColor2 = false
        this.istColor3 = false
      }
    },
    valiabe () {
      var enoughRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.//]).{8,20}$/
      if (enoughRegex.test(this.newpsd) === false) {
        this.$message({
          type: 'warning',
          message: '新密码必须由 8-20位大小字母、数字、特殊符号组成！'
        })
      }
    },
    isEqualold () {
      if (this.newpsd1 === this.newpsd) {
        this.isnew = true
      } else {
        this.isnew = false
      }
    },
    modifyPsdbn () {
      var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.//]).{8,20}$/
      // else if (this.newpsd === '') {
      //   this.$message({
      //     type: 'warning',
      //     message: '请重复输入新密码！'
      //   })
      // }
      if (this.oldpsd === '') {
        this.$message({
          type: 'warning',
          message: '旧密码未填写！'
        })
      } else if (this.newpsd === '') {
        this.$message({
          type: 'warning',
          message: '新密码未填写！'
        })
      } else if (this.newpsd !== this.newpsd1) {
        this.$message({
          type: 'warning',
          message: '两次输入的密码不一样，请重新输入！'
        })
      } else if (reg.test(this.newpsd1) === false) {
        this.$message({
          type: 'warning',
          message: '新密码必须由 8-20位大小字母、数字、特殊符号组成!'
        })
      } else {
        let userName = cookie.getCookie('user_name')
        let md5Newpwd = this.$md5(this.newpsd)
        let md5Oldpwd = this.$md5(this.oldpsd)
        let url = `user/updatePassword?password=${md5Oldpwd}&newPassWord=${md5Newpwd}&userName=${userName}`
        this.$https.post(url).then(response => {
          if (response.code === '200') {
            this.$message({
              message: '恭喜你，密码修改成功',
              type: 'success'
            })
            setTimeout(() => {
              this.$router.push({
                path: '/login'
              })
            }, 3000)
          }
          if (response.success === true) {
            this.dialogVisible1 = false
            this.$message({
              type: 'success',
              message: '密码修改成功！'
            })
          } else {
            this.$message({
              type: 'warning',
              message: response.msg
            })
          }
        }).catch(() => {
          this.$message({
            type: 'warning',
            message: '密码修改失败！'
          })
        })
      }
    },
    // 修改密码尾部
    // 退出登录
    loginOut () {
      // 清除cookie缓存
      // cookie.clearCookie();
      cookie.clearCookie()
      localStorage.setItem('E-User-Token', '')
      sessionStorage.setItem('E-User-Token', '')
      this.$store.dispatch('clearCityProjectAllData')
      this.$store.dispatch('ClearMenuList')
      this.$store.dispatch('ClearOperationList')
      this.$store.dispatch('Logout')
      this.$router.push({
        name: 'login'
      }) // 跳转到登录页
    },
    isEditEnter () {
      this.isEidet = true
    },
    isEditLeave () {
      this.isEidet = false
    },
    adminDoEnter () {
      this.adminDo = true
    },
    adminDoLeave () {
      this.adminDo = false
    },
    handleCloseBn (done) {
      this.$confirm('确认关闭？').then(_ => {
        done()
      }).catch(_ => {})
    },
    change (index) {
      this.selected = index
    },
    toLink (o) {
      this.$router.push({
        name: o.menuName
      })
    },
    exitLogin () {
      const url0 = 'logout?uid=' + 2
      this.$https.get(url0).then(response => {
        this.$router.push({
          name: 'login'
        })
      }).catch(error => {
        console.log(error)
      })
    },
    dynamicMenu (obj) {
      let originStr = JSON.stringify(obj)
      let str = this.menu
      for (let i in str) {
        if (originStr.indexOf && originStr.indexOf(str[i]) !== -1) {
          this.disFlag[i] = true
          if (i >= 1 && i <= 4) {
            this.submenu1 = true
          } else if (i >= 5 && i <= 9) {
            this.submenu2 = true
          } else if (i >= 10 && i <= 16) {
            this.submenu3 = true
          } else {
            this.submenu4 = true
          }
        }
      }
    },
    themeChanged () {
      const changeColor = () => {
        var myDiv = document.querySelector(`.${this.$options.name}__head`)
        var finalStyle = myDiv.currentStyle ? myDiv.currentStyle : document.defaultView.getComputedStyle(myDiv, null)
        this.backgroundColor = (finalStyle.backgroundColor.indexOf('#') === -1 ? colorRGBtoHex(finalStyle.backgroundColor) : finalStyle.backgroundColor)
        this.fontColor = getComputedStyle(document.querySelector(`.${this.$options.name}__head`)).color
      }
      this.$nextTick(changeColor)
      setTimeout(changeColor, 100)
    },
    projectTreeDataLoaded (val) {
      const backToLogin = () => {
        localStorage.removeItem('selectedProject_' + this.$store.getters.user.id)
        this.$message({
          showClose: true,
          message: '请重新登录选择项目',
          type: 'error'
        })
        this.$router.push({
          name: 'login'
        })
      }
      const projectId = localStorage.getItem('selectedProject_' + this.$store.getters.user.id)
      if (!projectId) {
        backToLogin()
      } else {
        const findProject = (projectId, list) => {
          for (const projectData of list) {
            if (projectData.id === projectId) {
              return projectData
            } else if (projectData.children && projectData.children.length) {
              const subProjectData = findProject(projectId, projectData.children)
              if (subProjectData) {
                return subProjectData
              }
            } else {
              // sonar规则校验语法必须else
            }
          }
          return null
        }
        const selectedProject = findProject(parseInt(projectId), val)
        if (!selectedProject) {
          backToLogin()
        } else {
          this.$store.commit('SET_USER_SELECTED_PROJECT', selectedProject)
          this.projectName = selectedProject.name
          this.projectId = selectedProject.id
        }
      }
    },
    projectSelected (val, isAutoSelected) {
      if (val.projectCode && !isAutoSelected) {
        if (val.id !== this.$store.getters.user.selectedProject.id) {
          this.projectName = val.name
          this.$store.commit('SET_USER_SELECTED_PROJECT', val)
          localStorage.setItem('selectedProject_' + this.$store.getters.user.id, val.id)
          this.$router.replace({
            name: 'refresh',
            query: {
              path: this.$route.fullPath
            }
          })
        }
        this.$refs.projectTreeInput.hideProjectTree()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/layout.js